module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-down-right-a733c3968cbaafba350e552252fe1c18.svg";